import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';

import { Provider } from 'blockchain';
import { IMainLayoutMenuLink, IStoreModel, IWalletState, TradeTypes } from 'types';
import { Routes, UserRole } from 'constants/index';
import useFetch from 'hooks/useFetch';
import { LabelPrimary } from 'components';

import BasicMainLayoutView from '../basic/BasicMainLayoutView';

interface IProps {
  children?: ReactNode;
}

const menuLinks: Array<IMainLayoutMenuLink> = [
  {
    key: 'admin',
    icon: 'dashboard',
    name: 'admin',
    path: Routes.admin,
    roles: [UserRole.Admin],
  },
  {
    key: 'superAdmin',
    icon: 'dashboard',
    name: 'superAdmin',
    path: Routes.superAdmin,
    roles: [UserRole.Superadmin],
  },
  {
    key: '1',
    icon: 'projects',
    name: 'projects',
    path: Routes.projects,
  },
  {
    key: '2',
    icon: 'portfolio',
    name: 'portfolio',
    path: Routes.portfolio,
    isWalletRequired: true,
  },
  {
    key: '3',
    icon: 'wallet',
    name: 'transactions',
    path: Routes.transactions,
    isWalletRequired: true,
  },
  {
    key: '4',
    icon: 'project',
    name: 'myProject',
    path: Routes.myProject,
    roles: [UserRole.Project],
  },
  {
    key: '5',
    icon: 'company',
    name: 'myCompany',
    path: Routes.myCompany,
    roles: [UserRole.Company],
  },
  {
    key: '6',
    icon: 'auction',
    name: 'myAuctions',
    path: Routes.myAuctions,
    isWalletRequired: true,
  },
  {
    key: '7',
    icon: 'burned',
    name: 'burned',
    path: Routes.burned,
    roles: [UserRole.Company],
  },
  {
    key: '9',
    icon: 'dex',
    name: 'trading',
    path: Routes.trading,
    isWalletRequired: true,
    query: { type: TradeTypes.Bid },
  },
  {
    key: '10',
    icon: 'project',
    name: 'myCommunityProject',
    path: Routes.myCommunityProject,
    roles: [UserRole.Community],
  },
];

const UserMainLayoutView = ({ children }: IProps) => {
  const { t } = useTranslation(['views/common', 'common']);
  const wallet = useStoreState<IStoreModel, IWalletState>((store) => store.blockchain.wallet);

  const { response: balance } = useFetch(async () => {
    return wallet.walletAddress ? await Provider.getBalance(wallet.walletAddress) : null;
  }, [wallet.walletAddress]);

  return (
    <BasicMainLayoutView
      menuLinks={menuLinks}
      sidebarActions={
        <LabelPrimary>
          {balance ? (+balance).toFixed(2) : '0.00'} {t('common:blockchain.unit')}
        </LabelPrimary>
      }
    >
      {children}
    </BasicMainLayoutView>
  );
};

export default UserMainLayoutView;
